// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"aec69818","605":"6d05696a","725":"b1ba1107"}[chunkId] + ".chunk.js";
};